import React from 'react';
import { Container } from 'reactstrap';

import Layout from '../components/Layout';

const NotFoundPage = () => (
  <Layout title="404">
    <Container>
      <div className="section">
        <h1>404 Not Found</h1>
        <p>We couldn't find the page you were looking for.</p>
      </div>
    </Container>
  </Layout>
);

export default NotFoundPage;
